import { Layout } from 'antd'
import { SiderProps } from 'antd/lib'

import { useStyles } from './styles'

type Props = {
  isCollapsed: boolean
} & SiderProps

export const Sider = ({ isCollapsed, children, ...props }: Props) => {
  const { styles } = useStyles()

  return (
    <Layout.Sider
      className={styles.sider}
      width={264}
      collapsible
      collapsed={isCollapsed}
      trigger={null}
      {...props}
    >
      {children}
    </Layout.Sider>
  )
}
